import { render, staticRenderFns } from "./Trowser.vue?vue&type=template&id=0e54ad4d&scoped=true"
import script from "./Trowser.vue?vue&type=script&lang=js"
export * from "./Trowser.vue?vue&type=script&lang=js"
import style0 from "./Trowser.vue?vue&type=style&index=0&id=0e54ad4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e54ad4d",
  null
  
)

export default component.exports